
import API_CONFIG, { getApiUrl, tokenManager } from '../config';
import { fetchApi } from './api';

// For OTP-based login (existing)
export const sendOTP = async (phoneNumber) => {
  try {
    const response = await fetch(`${API_CONFIG.baseUrl}/user/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('OTP sent successfully:', data);
    return data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};

export const verifyOTP = async (phoneNumber, otp) => {
  try {
    const response = await fetch(`${API_CONFIG.baseUrl}/user/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, otp }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('OTP verified successfully:', data);
    return data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};

// Admin login with password
export const adminLogin = async (phoneNumber, password) => {
  const data = await fetchApi('/login', {
    method: 'POST',
    body: { phoneNumber, password },
  });
  
  // Store the token
  if (data.token) {
    tokenManager.setToken(data.token);
  }
  
  return data;
};

// Admin register
export const adminRegister = async (registerData) => {
  return fetchApi('/register', {
    method: 'POST',
    body: registerData,
  });
};
// Logout
export const adminLogout = () => {
  tokenManager.removeToken();
  console.log('Admin logged out successfully');
};

// Get current token
export const getToken = () => {
  return tokenManager.getToken();
};

// Check if authenticated
export const isAuthenticated = () => {
  return !!tokenManager.getToken();
};

